module.exports = __webpack_public_path__ + "media/images/career_camp/2023/user_2-619d490e9e40aecbb6ac7be9a8bb43b0.png";